const handleADAOnGallery = () => {
    $('li.vjs-menu-title').each(function () {
        $(this).attr('role', 'menuitem')
    })

    $('ul.vjs-menu-content').each(function () {
        var innerElements = $(this).children()
        if (innerElements.length === 0) {
            $(this).append("<li role='menuitem' aria-label='dynamically added'></li>")
        }
    })
}

const handleZoomOnThreeSixty = () => {
    $('.Test360').bind('mousewheel DOMMouseScroll', function (e) {
        var scrollTo = null;

        if (e.type == 'mousewheel') {
            scrollTo = (e.originalEvent.wheelDelta * -1);
        }
        else if (e.type == 'DOMMouseScroll') {
            scrollTo = 40 * e.originalEvent.detail;
        }

        if (scrollTo) {
            e.preventDefault();
            $(this).scrollTop(scrollTo + $(this).scrollTop());
        }
    });
}

export { handleADAOnGallery, handleZoomOnThreeSixty }
